import { DetailTitle } from "../../shared/DetailTitle";

interface ActionItemHeaderProps {
  title: string;
  onDelete: () => void;
  onTitleChange: (title: string) => void;
}

export function ActionItemHeader({ title, onDelete, onTitleChange }: ActionItemHeaderProps) {
  return (
    <DetailTitle
      title={title}
      onTitleChange={onTitleChange}
      onDelete={onDelete}
      placeholder="Untitled Action Item"
    />
  );
}